import { netPriceItemSchema } from "./netPriceItemSchema";
import { z } from "zod";

export const discountInfoSchema = z.object({
  projectId: z.coerce.string(),
  projectOwner: z.coerce.string().optional(),
  basicDiscountPercentage: z.coerce.number(),
  onlineProductDiscountPercentage: z.coerce.number().optional(),
  netPricesForProducts: z.array(z.lazy(() => netPriceItemSchema)).optional(),
  discountsRequireManualProcessing: z.boolean().optional(),
  percentagePointDiscount: z.coerce
    .number()
    .describe(
      "If this exists, then basicDiscountPercentage, onlineDiscountPercentage and netPricesForProducts should be ignored",
    )
    .optional(),
});

export type DiscountInfo = z.infer<typeof discountInfoSchema>;
